export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-iphone-2.30230e46.svg";